import moment from 'moment';
import type { IntlShape } from 'react-intl';
import type { SelectOption } from '@rio-cloud/rio-uikit/Select';

import {
    AegBodyBuilderNameEnum,
    AegImplementOrBodyBuilderEnum,
    AegRepairScopeEnum,AegOption,
    AegRequestForm,
    AegOccurrenceRequest
} from '../models/newAEG';

export const getOptionLabel = (option: AegOption, intl: IntlShape): string =>
    option.labelId ? intl.formatMessage({ id: option.labelId }) : (option.label ?? '');

export const toSelectOptions = (options: AegOption[], intl: IntlShape): SelectOption[] =>
    options.map(option => ({
        id: option.id,
        label: getOptionLabel(option, intl),
    }));

export const toEnumOptions = <T extends string>(values: T[], labelPrefix: string): AegOption[] =>
    values.map(value => ({ id: value, labelId: `${labelPrefix}.${value}` }));

const toNumber = (value: string) => Number(value.replace(',', '.')) || undefined;

export const buildAegRequestPayload = (values: AegRequestForm): AegOccurrenceRequest => ({
    status: values.moveTo,
    requestType: values.requestType,
    approvalType: values.approvalType,
    responsible: values.responsible,
    dn: values.dn,
    regional: values.regional,
    dnResponsible: values.responsibleDn,
    phone: values.phone,
    chassis: values.chassis,
    licensePlate: values.licensePlate,
    vehicleType: values.vehicleType || undefined,
    customer: values.customer,
    implementOrBodyBuilder: values.implement || undefined,
    implementOrBodyBuilderOther:
        values.implement === AegImplementOrBodyBuilderEnum.OTHERS ? values.implementOther : undefined,
    bodyBuilderName: values.bodyBuilder || undefined,
    bodyBuilderNameOther: values.bodyBuilder === AegBodyBuilderNameEnum.OTHERS ? values.bodyBuilderOther : undefined,
    cargoTransport: values.cargo,
    odometer: toNumber(values.odometer),
    hourMeter: toNumber(values.hourMeter),
    repairDate: values.repairDate ? moment(values.repairDate).toISOString() : undefined,
    osNumber: values.serviceOrder,
    sgNumber: values.warrantyRequest,
    serviceType: values.serviceType || undefined,
    repairTotal: values.repairTotal,
    laborTotalUt: toNumber(values.laborTotal),
    hasThirdPartyService: values.hasThirdParty,
    thirdPartyServices: values.hasThirdParty ? values.thirdPartyServices : undefined,
    thirdPartyInvoiceAmount: values.hasThirdParty ? values.thirdPartyInvoiceValue : undefined,
    thirdPartyInvoiceNumbers: values.hasThirdParty ? values.thirdPartyInvoiceNumber : undefined,
    repairScope: values.repairScope,
    partialPercentage:
        values.repairScope === AegRepairScopeEnum.PARTIAL ? toNumber(values.repairPercentage) : undefined,
    controlCode: values.controlCode,
    chameVolksNumber: values.chameVolks,
    breakdown: values.breakdown ? 'YES' : 'NO',
    customerComplaint: values.customerComplaint,
    dnDiagnosis: values.dnDiagnosis,
    dnJustification: values.dnJustification,
    attendanceCondition: values.serviceCondition || undefined,
    fleetComposition: values.fleetComposition,
    lastVwcoManPurchase: values.lastPurchase ? moment(values.lastPurchase).toISOString() : undefined,
    companies: values.companies,
    moveTo: values.moveTo,
    assignTo: values.assignTo || undefined,
});
